import React, { Component } from 'react';
import { Container, Grid, Button, Typography, Box } from '@material-ui/core';
import '../CSS/RemoteSpaceSelect.css';
import SearchForm from './SearchForm';
import ReservationTabs from './ReservationTabs';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import RemoteUserDetails from './RemoteUserDetails';
import { Diversity1Sharp } from '@mui/icons-material';
const theme = createTheme({
    palette: {
        primary: {
            main: '#2dcd7a',
        },
    },
});

class RemoteSpaceSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {

            //view changing variables
            selectSpace: true,
            userDetails: false,

            //selected space
            spaceName: '',
            siteType: '',
            siteId: '',
            siteTypeId: '',
            daily: '',
            sunday: '',
            monday: '',
            tuesday: '',
            wednesday: '',
            thursday: '',
            friday: '',
            saturday: '',
            weekly: '',
            monthly: '',

            guests: this.props.guests || 0,
            pets: this.props.pets || 0,
            children: this.props.children || 0,
        };
    }

    handleSelect = async (space) => {
        this.setState({
            spaceName: space.space_name,
            siteType: space.sitetype_name,
            daily: space.daily_rate,
            sunday: space.sunday,
            monday: space.monday,
            tuesday: space.tuesday,
            wednesday: space.wednesday,
            thursday: space.thursday,
            friday: space.friday,
            saturday: space.saturday,
            weekly: space.weekly_rate,
            monthly: space.monthly_rate,
            siteId: space.id,
            siteTypeId: space.sitetype_id,
            selectSpace: false,
            userDetails: true,
        })
    }

    backToSelectSpace = () => {
        this.setState({
            selectSpace: true,
            userDetails: false,
        })
    }

    handleUpdateState = (field, value) => {
        this.setState({ [field]: value });
    };

    render() {
        return (
            <Grid className='remoteSpaceSelect'>
                {this.state.selectSpace
                    ?
                    <>
                        <Box>
                            <SearchForm checkIn={this.props.checkIn} checkOut={this.props.checkOut}
                                guests={this.state.guests} rigType={this.props.rigType} pets={this.state.pets}
                                slides={this.props.slides} children={this.state.children} rigLength={this.props.rigLength}
                                sites={this.props.sites} rigs={this.props.rigs} serverName={this.props.serverName}
                                updateSpace={this.props.updateSpace} siteType={this.props.siteType} updateState={this.handleUpdateState} />
                        </Box>
                        <Box style={{ width: "90%", margin: "0px auto" }}>
                            <ReservationTabs spaceData={this.props.spaceData} bookSpace={this.handleSelect} facilities={this.props.facilities}
                                additionalDetails={this.props.additionalDetails} addressLine1={this.props.addressLine1} addressLine2={this.props.addressLine2}
                                addressLine3={this.props.addressLine3} rules={this.props.rules} changes={this.props.changes} mapURL={this.props.mapURL} />
                        </Box>
                    </>
                    : <RemoteUserDetails sites={this.props.sites} rigs={this.props.rigs} extras={this.props.extras}
                        checkIn={this.props.checkIn} checkOut={this.props.checkOut} guests={this.state.guests}
                        rigType={this.props.rigType} pets={this.state.pets} rigLength={this.props.rigLength}
                        boatBeam={this.props.boatBeam} boatLength={this.props.boatLength} boatDraft={this.props.boatDraft} siteLength={this.props.siteLength} boatType={this.props.boatType} freshWater={this.props.freshWater} pumpOut={this.props.pumpOut} e15a={this.props.e15a} e30a={this.props.e30a} e50a={this.props.e50a} e100a={this.props.e100a}
                        slides={this.props.slides} children={this.state.children} spaceData={this.props.spaceData}
                        spaceName={this.state.spaceName} siteId={this.state.siteId} daily={this.state.daily}
                        sunday={this.state.sunday} monday={this.state.monday} tuesday={this.state.tuesday} wednesday={this.state.wednesday} thursday={this.state.thursday} friday={this.state.friday} saturday={this.state.saturday}
                        weekly={this.state.weekly} monthly={this.state.monthly} siteType={this.state.siteType}
                        siteTypeId={this.state.siteTypeId} serverName={this.props.serverName} backToSelectSpace={this.backToSelectSpace}
                        allow={this.props.allow} require={this.props.require} user={this.props.user} />
                }
            </Grid >
        )
    };
};

export default RemoteSpaceSelect;